import React from 'react'

export default ({}) =>
    <footer>
        <div className="copyright">
            <p>© 2017. Powered By <a href="https://github.com/picidaejs/picidae">Picidae</a></p>
        </div>
    </footer>


// WEBPACK FOOTER //
// ./~/picidae-theme-grass/template/Comps/Footer.js